import React, { Component } from "react";
// Redux stuff
import { connect } from "react-redux";
import { login } from "../../redux/actions/providerActions";

//Styles
import styles from "./login.module.css";

import AlbumIcon from "@material-ui/icons/Album";
import ButtonLoading from "../../components/buttonLoading/ButtonLoading";

// @ts-check

/**
 * Class representing a dot.
 * @extends Login
 */

class Login extends Component {
    constructor(props) {
        super(props);

        /**
         * Component Default State
         * @type {{accountType: string, email: string, password: string}}
         * @example
         * this.state = {
         *    accountType: "student",
         *    email: "",
         *    password: "",
         * };
         */

        this.state = {
            accountType: "student",
            email: "",
            password: "",
        };
    }

    render() {
        const { accountType, email, password } = this.state;
        const { loading } = this.props.provider;

        const onInputChange = (e) => {
            this.setState({
                [e.target.name]: e.target.value,
            });
        };

        const uploadData = (e) => {
            e.preventDefault();
            const data = {
                accountType: accountType,
                email: email,
                password: password,
            };
            this.props.login(data, this.props.history);
        };

        return (
            <div
                className={styles.container}
                style={{ backgroundImage: "url(./signupBack.svg)" }}
            >
                <form onSubmit={(e) => uploadData(e)}>
                    <div className={styles.card}>
                        <div className={styles.formGroupForTwo}>
                            <div className={styles.formGroup}>
                                <h1 style={{ margin: 0 }}>College-X</h1>
                            </div>
                        </div>

                        <div className={styles.formGroupForTwo}>
                            <div className={styles.formGroup}>
                                <label name="accountType">
                                    Login Type <AlbumIcon />
                                </label>
                                <select
                                    name="accountType"
                                    value={accountType}
                                    onChange={(e) => onInputChange(e)}
                                >
                                    <option value="student">Student</option>
                                    <option value="teacher">Teacher</option>
                                </select>
                            </div>
                        </div>

                        <div className={styles.formGroupForTwo}>
                            <div className={styles.formGroup}>
                                <label htmlFor="email">
                                    Email <AlbumIcon />{" "}
                                    <span>
                                        (Use College Provider E-mail ID)
                                    </span>
                                </label>
                                <input
                                    onChange={(e) => onInputChange(e)}
                                    value={email}
                                    type="text"
                                    name="email"
                                    placeholder="username@domain.com"
                                />
                            </div>
                        </div>

                        <div className={styles.formGroupForTwo}>
                            <div className={styles.formGroup}>
                                <label htmlFor="password">
                                    Password <AlbumIcon />
                                </label>
                                <input
                                    onChange={(e) => onInputChange(e)}
                                    value={password}
                                    type="password"
                                    name="password"
                                    placeholder=""
                                />
                            </div>
                        </div>

                        <div className={styles.submitButtonContainer}>
                            <button
                                type="submit"
                                className={styles.submitButton}
                                disabled={loading ? true : false}
                            >
                                {loading ? (
                                    <ButtonLoading height="16px" width="16px" />
                                ) : (
                                    "Welcome Back!"
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    provider: state.provider,
});

export default connect(mapStateToProps, { login })(Login);
